import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/business-partner/$id/_layout/bp-role-info/_layout/$bpRole/')({
  component: () => null
});